// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".receipt__row_active[data-v-b7fd7dd2]{font-weight:bold}.receipt__content-container[data-v-b7fd7dd2]{max-height:65vh;overflow-y:auto;overflow-x:hidden}\n", ""]);
// Exports
module.exports = exports;
